<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name">
        <el-input v-model="queryParams.name" placeholder="名称"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="description" >
        <el-input v-model="queryParams.description" placeholder="描述内容"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd" >添加</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="name" label="方案名称" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="description" label="描述" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" width="100" align="center" v-if="checkPermi(['agent:orientation:update'])" fixed="right">
            <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handleDel(row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 添加方案公司 -->
    <el-dialog title="方案添加" :visible.sync="open" width="680px" @close="cancel" append-to-body destroy-on-close :close-on-click-modal="false">
      <el-form ref="serviceForm" :model="serviceForm" :rules="serviceRule" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="方案名称" prop="name">
              <el-input v-model="serviceForm.name" clearable placeholder="请输入方案公司名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="description">
              <el-input v-model="serviceForm.description" type="textarea" clearable placeholder="请输入描述" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="serviceForm.remark" type="textarea" clearable placeholder="请输入备注" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { serviceProviderList , saveServiceProvider , updateServiceProvider ,removeServiceProvider} from "@/api/api.js";
export default {
  name: "serviceProvider",
  data() {
    return{
      queryParams:{
        name:undefined,
        description:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      open:false,
      submitLoading:false,
      serviceForm:{
        id:undefined,
        name:undefined,
        description:undefined
      },
      serviceRule: {
        name: [
          { required: true, message: "方案名称不能为空", trigger: "blur" },
        ],
      },
      updateFormOpen:false,
      updateLoading:false,
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model: {
          ... this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      serviceProviderList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 关闭弹窗
    dialogClose(){
      this.dialog = false;
      this.initData();
    },
    handleAdd(){
      this.open = true;
    },
    submitForm(){
      this.$refs["serviceForm"].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          if(!this.serviceForm.id){
            saveServiceProvider(this.serviceForm).then(res => {
                this.$notify.info({
                    title: "提示",
                    message: "数据添加成功",
                    duration: 1000,
                    offset:30
                });
                this.submitLoading = false;
                this.cancel();
                this.resetQuery();
            }).catch(() => {
                this.submitLoading = false;
            })
          }else{
            updateServiceProvider(this.serviceForm).then(res => {
                this.$notify.info({
                    title: "提示",
                    message: "数据修改成功",
                    duration: 1000,
                    offset:30
                });
                this.submitLoading = false;
                this.cancel();
                this.resetQuery();
            }).catch(() => {
                this.submitLoading = false;
            })
          }
        }
      });
    },
    cancel(){
      this.serviceForm.id = undefined
      this.$refs.serviceForm.resetFields()
      this.open = false;
    },
    handleUpdate(row){
      this.serviceForm = {...row};
      this.open = true;
    },
    handleDel(row){
      this.$confirm('确认作废吗此记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeServiceProvider({id:row.id}).then(res => {
          this.$notify.info({
            title: "提示",
            message: "删除成功",
            duration: 1000,
            offset:30
          });
          this.resetQuery();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
  },
  created() {
    this.initData();
  }
};
</script>



